import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiazai",
  "use": "icon-xiazai-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-xiazai\"><defs><style type=\"text/css\"></style></defs><path d=\"M185.728 659.52v144.384h652.544v-144.384H928v236.288h-832v-236.288h89.728z m372.288-531.712v336.128h104.064L522.88 697.28h-18.56L364.032 464h104.32V127.808h89.664z\" p-id=\"8730\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol